export const BUSINESS_NAME = "BABA GARMENTS";
export const TAGLINE = "Complete Family Fashion Store";
export const ADDRESS = "80/77-D, Near Hamraj Complex, Cooper Ganj, Kanpur, Uttar Pradesh";
export const PHONE_1 = "+91 93351 70049";
export const PHONE_2 = "+91 76071 09875";
export const TEL_1 = "tel:+919335170049";
export const TEL_2 = "tel:+917607109875";
export const WA_NUMBER = "919335170049";
export const IG_HANDLE = "@baba_garmentss";
export const IG_LINK = "https://instagram.com/baba_garmentss";
export const MAPS_LINK =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent("80/77-D, Near Hamraj Complex, Cooper Ganj, Kanpur, Uttar Pradesh");
export const DEFAULT_WA_MSG =
    "Namaste! I want wholesale rates & the latest catalogue from Baba Garments.";

export const waLink = (msg) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg || DEFAULT_WA_MSG)}`;

const U = (id, w = 1400) =>
    `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
    hero: U("1554583797-69a28298654c", 1600),
    men: U("1529720317453-c8da503f2051", 1200),
    women: U("1532453288672-3a27e9be9efd", 1200),
    kids: U("1665815844395-06f64f44b5e3", 1200),
    fabric: U("1580250569064-b2ac463aa820", 1200),
    store: U("1722957533029-6b62a3826d05", 1200),
};